import { FieldReviewTable } from '../fieldReviewTable';
// import { SpecialConditionsList } from '../specialConditions/specialConditionsList';

export interface WholesalerContractReviewTableProps {
  data: Record<string, any>;
}

export const WholesalerContractReviewTable = ({ data }: WholesalerContractReviewTableProps) => {
  return (
    <>
      <FieldReviewTable items={data?.items} />
      {/*
        Special Conditions UI is parked pending business review of what the field
        should surface. The backend still extracts and stores specialConditions, so
        no data is lost while this is off - only the rendering is disabled.
        Re-enable by uncommenting this and the import above, plus the matching
        blocks in wholesalerContractEditModal.tsx and wholesalerContractFormStore.ts.

        <SpecialConditionsList conditions={data?.specialConditions} />
      */}
    </>
  );
};
